import { Task } from '@admiin-com/ds-graphql';
import { WBFlex } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import { useDocumentUrl } from '../../../hooks/useDocumentUrl/useDocumentUrl';
import { PdfScrollProvider } from '../../../components/PdfSign/PdfScrollContext';
import { frontDateFromBackendDate } from '@admiin-com/ds-common';
import { SignDesktop } from './components/SignDesktop';
import { SignMobile } from './components/SignMobile';
import { useSignFunc } from '../../hooks/useSignFunc/useSignFunc';
import SignPayLayout from '../layout/SignPayLayout';
import { useTaskFromToName } from '../../../hooks/useTaskToName/useTaskToName';
interface Props {
  task: Task;
  onClose: () => void;
  onNext?: () => void;
  nextButtonText?: string;
  timeout?: number;
}
export const SignModalContent = (props: Props) => {
  const { t } = useTranslation();
  const { documentUrl } = useDocumentUrl(props.task);
  const updateAnnotations = useSignFunc({
    task: props.task,
  });
  const onNext = () => {
    props.onNext?.();
  };

  const { from, to } = useTaskFromToName(props.task);

  const properties = [
    { label: t('from', { ns: 'taskbox' }), value: from ?? '' },
    ...(to ? [{ label: t('to', { ns: 'taskbox' }), value: to ?? '' }] : []),
    {
      label: t('dueAt', { ns: 'taskbox' }),
      value: frontDateFromBackendDate(props.task.dueAt),
    },
  ];

  return (
    <SignPayLayout
      title={t('requestForSignature', { ns: 'taskbox' })}
      onClose={props.onClose}
    >
      {props.task.annotations && (
        <PdfScrollProvider
          annotations={props.task.annotations}
          onSave={async (annotation: string, pdf: any) => {
            await updateAnnotations(annotation, pdf);
            setTimeout(() => {
              props.onNext?.();
            }, props.timeout ?? 5000);
          }}
          taskGuest={props.task}
        >
          <WBFlex
            flexDirection="column"
            display={['none', 'block']}
            width="100%"
            flex={1}
          >
            <SignDesktop
              documentUrl={documentUrl}
              onNext={props.onNext ? onNext : undefined}
              properties={properties}
              taskGuest={props.task}
              nextButtonText={props.nextButtonText}
            />
          </WBFlex>
          <WBFlex
            flexDirection="column"
            display={['block', 'none']}
            width="100%"
            flex={1}
          >
            <SignMobile
              documentUrl={documentUrl}
              onNext={props.onNext ? onNext : undefined}
              properties={properties}
              taskGuest={props.task}
              nextButtonText={props.nextButtonText}
            />
          </WBFlex>
        </PdfScrollProvider>
      )}
    </SignPayLayout>
  );
};
export default SignModalContent;
